import cx from "classnames";
import { ReactNode } from "react";

import { CompositionDiagram } from "./components/CompositionDiagram";
import { CompositionTable } from "./components/CompositionTable";
import { CompositionItem, CompositionType } from "./hooks/useCompositionData";

type Props = {
  title: ReactNode;
  label: ReactNode;
  composition: CompositionItem[];
  type: CompositionType;
};

export function MarketComposition({ title, label, composition, type }: Props) {
  return (
    <div className="flex size-full grow flex-col items-start border-stroke-primary pt-24">
      <h5 className="text-13 font-medium text-gray-lighter">{title}</h5>
      <div className="mt-4 flex items-center gap-24 sm:mt-11">
        <div className="px-16 py-20">
          <CompositionDiagram data={composition} label={label} />
        </div>
        <div className={cx("relative w-full flex-grow overflow-y-auto overflow-x-hidden")}>
          <CompositionTable composition={composition} compositionType={type} />
        </div>
      </div>
    </div>
  );
}
